import { IconBrandGooglePodcasts, IconReceipt2, IconChartInfographic } from '@tabler/icons';

const dashboard = {
  id: 'default',
  title: 'Contract',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Contract',
      type: 'item',
      url: '/transaction/default',
      icon: IconBrandGooglePodcasts,
      breadcrumbs: false
    },
    {
      id: 'bill',
      title: 'Bills',
      type: 'item',
      url: '/transaction/bill',
      icon: IconReceipt2,
      breadcrumbs: false
    },
    {
      id: 'summary',
      title: 'Summary',
      type: 'item',
      url: '/transaction/summary',
      icon: IconChartInfographic,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
